function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\u56FE\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 336.216 93.622",
    style: {
      enableBackground: "new 0 0 336.216 93.622"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    style: {
      fill: "#134980"
    },
    d: "M293.107,66.573H39.393C25.427,66.573,14,55.146,14,41.18v0 c0-13.966,11.427-25.393,25.393-25.393h253.713c13.966,0,25.393,11.427,25.393,25.393v0C318.5,55.146,307.073,66.573,293.107,66.573 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_41_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_64_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M37.231,28.603l5.643,18.885l5.267-18.885h5.944l5.266,18.885l5.643-18.885h5.492 l-8.088,25.092h-6.095L51.113,35.6l-5.192,18.095h-6.094l-8.126-25.092H37.231z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_67_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M98.965,35.299v18.396h-5.116V28.603h6.847l9.969,18.697V28.603h5.078v25.092h-6.546 L98.965,35.299z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_69_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M127.179,33.08h-7.975v-4.477h21.631v4.477h-8.314v20.616h-5.342V33.08z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_50_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_60_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.018,49.218v4.477h-9.405h-2.032c-2.106,0-3.549-0.032-4.326-0.094 c-0.778-0.062-1.706-0.219-2.784-0.47c-2.809-0.651-4.878-2.257-6.207-4.815c-1.004-1.957-1.505-4.301-1.505-7.035 c0-4.765,1.191-8.175,3.574-10.233c2.032-1.73,4.966-2.595,8.803-2.595c2.532,0,4.74,0.426,6.621,1.278 c1.179,0.552,2.144,1.229,2.897,2.032c0.753,0.803,1.354,1.843,1.806,3.123c0.727,1.981,1.091,4.013,1.091,6.094 c0,3.211-0.928,5.958-2.784,8.239H179.018z M165.174,32.666c-2.207,0-3.843,0.671-4.909,2.013c-1.066,1.342-1.599,3.38-1.599,6.113 c0,2.383,0.351,4.314,1.053,5.794c0.928,1.931,2.759,2.896,5.493,2.896c2.558,0,4.326-0.89,5.304-2.671 c0.753-1.354,1.128-3.322,1.128-5.906c0-2.357-0.451-4.276-1.354-5.756C169.261,33.519,167.556,32.691,165.174,32.666z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M188.309,28.604v15.048c0,1.204,0.1,2.138,0.301,2.802 c0.2,0.665,0.539,1.236,1.016,1.712c1.053,1.029,2.52,1.542,4.401,1.542c1.204,0,2.251-0.207,3.142-0.62 c0.89-0.414,1.511-0.972,1.862-1.674c0.351-0.703,0.527-1.957,0.527-3.762V28.604h5.342v14.783c0,1.957-0.206,3.568-0.62,4.835 c-0.414,1.266-1.048,2.289-1.9,3.066c-1.981,1.73-4.791,2.595-8.427,2.595c-3.887,0-6.721-0.852-8.502-2.558 c-0.928-0.877-1.567-1.861-1.918-2.953c-0.352-1.091-0.527-2.627-0.527-4.608V28.604H188.309z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M221.528,28.453c2.507,0,4.715,0.426,6.621,1.278c2.232,1.029,3.8,2.747,4.702,5.154 c0.702,1.881,1.054,4.088,1.054,6.62c0,2.558-0.427,4.778-1.279,6.659c-1.079,2.232-2.734,3.8-4.966,4.702 c-1.656,0.653-3.562,0.978-5.718,0.978c-2.834,0-5.292-0.527-7.374-1.581c-1.755-0.877-3.098-2.257-4.025-4.138 c-0.928-1.881-1.392-4.162-1.392-6.847c0-4.789,1.191-8.201,3.574-10.233C214.731,29.343,217.666,28.477,221.528,28.453z  M221.565,32.666c-2.458,0-4.213,0.803-5.266,2.408c-0.853,1.255-1.279,3.273-1.279,6.057c0,2.934,0.527,5.092,1.58,6.471 c1.054,1.354,2.721,2.032,5.004,2.032c2.207,0,3.831-0.689,4.871-2.07c1.04-1.379,1.561-3.511,1.561-6.395 c0-2.633-0.427-4.64-1.279-6.019C225.779,33.519,224.048,32.691,221.565,32.666z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M243.986,33.079h-7.975v-4.476h21.632v4.476h-8.314v20.616h-5.342V33.079z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M282.733,53.696v-4.477h11.475c1.83,0,3.047-0.175,3.648-0.527 c0.878-0.527,1.318-1.316,1.318-2.37c0-1.229-0.514-2.12-1.543-2.671c-0.577-0.326-1.505-0.49-2.784-0.49h-4.664 c-2.835,0-4.879-0.513-6.133-1.542c-0.778-0.653-1.386-1.467-1.825-2.446c-0.438-0.978-0.658-2.032-0.658-3.161 c0-1.755,0.513-3.36,1.542-4.815c1.003-1.405,2.608-2.231,4.815-2.482c0.753-0.076,1.869-0.113,3.348-0.113h12.453v4.476h-11.248 c-1.681,0.026-2.797,0.1-3.349,0.227c-1.128,0.276-1.692,1.128-1.692,2.557c0,1.205,0.476,2.007,1.429,2.409 c0.627,0.3,1.68,0.451,3.161,0.451h4.025c2.056,0,3.586,0.176,4.59,0.527c1.781,0.603,3.009,1.656,3.686,3.161 c0.527,1.204,0.79,2.496,0.79,3.875c0,1.53-0.351,2.896-1.053,4.1c-0.977,1.706-2.446,2.735-4.401,3.085 c-0.954,0.151-2.395,0.227-4.327,0.227H282.733z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_49_",
    style: {
      fill: "#134980"
    },
    points: "161.501,66.573 161.501,78.329 140.183,66.573 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_48_",
    style: {
      fill: "#134980"
    },
    points: "189.715,66.573 189.715,78.329 168.397,66.573 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    style: {
      fill: "#E5AC31"
    },
    d: "M74.349,53.883V40.842h6.596V38.56c0-3.103-2.434-4.89-6.596-4.89v-5.216 c12.71,0,15.666,5.386,15.666,13.367v12.063H74.349z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    style: {
      fill: "#E5AC31"
    },
    d: "M278.069,28.528v12.906H270.7v2.259c0,3.071,2.719,4.84,7.369,4.84v5.163 c-14.198,0-17.501-5.331-17.501-13.229V28.528H278.069z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.23390e994fe6270be953d92b66e888e1.svg";
export { ForwardRef as ReactComponent };